<template>
       <div class="w-full max-w-[450px]">
              <div class="w-full inset-0 z-50 outline-none">
                     <form v-on:submit.prevent="auth()">
                            <div class="relative w-full">
                                   <!--content-->
                                   <div class="rounded-[4px] relative flex flex-col w-full  outline-none focus:outline-none">
                                          <div class="relative flex flex-col justify-start items-center space-y-[39px] w-full">
                                                 <div class="space-y-[26px] w-full">
                                                        <div class="relative w-full">
                                                                  <FloatLabel variant="on">
                                                                               <InputText
                                                                               fluid
                                                                                            id="phone"
                                                                                            v-model="authInfo.phoneNumber"
                                                                                           
                                                                               />
                                                                               <label for="phone">{{ t('phoneNumber') }}</label>
                                                                  </FloatLabel>
                                                                  <span v-if="v$.phoneNumber.$error" class="text-ody_sm text-red-500">
                                                                               {{ v$.phoneNumber.$errors[0].$message }}
                                                                  </span>
                                                        </div>

                                                        <div class="relative w-full">
                                                                  <FloatLabel variant="on">
                                                                               <InputText
                                                                                            fluid
                                                                                            :type="showPassword ? 'text' : 'password'"
                                                                                            id="password"
                                                                                            v-model="authInfo.password"
                                                                               />
                                                                               <label for="password">{{ t('password') }}</label>
                                                                  </FloatLabel>
                                                                  <span v-if="v$.password.$error" class="text-ody_sm text-red-500">
                                                                               {{ v$.password.$errors[0].$message }}
                                                                  </span>
                                                        </div>
                                                 </div>
                                          </div>

                                          <div class="flex pt-2 items-center">
                                                 <Checkbox
                                                        v-model="showPassword"
                                                        inputId="checked-checkbox"
                                                        class="mr-2"
                                                        :binary="true"
                                                 />
                                                 <label for="checked-checkbox" class="text-sm font-medium ">
                                                        {{ t('showPassword') }}
                                                 </label>
                                          </div>

                                          <div class="w-full flex items-center justify-center space-x-[10px] mt-[54px]">
                                                 <Button
                                                        :loading="loading"
                                                        id="login"
                                                      fluid
                                                        label="Login"
                                                        @click="auth"
                                                 />
                                                        
                                                
                                          </div>
                                   </div>
                            </div>
                     </form>
              </div>
       </div>
</template>

<script lang="ts">
import { defineComponent, reactive, computed } from 'vue';
import useValidate from '@vuelidate/core';
import { required, numeric } from '@vuelidate/validators';
import { useI18n } from 'vue-i18n';


export default defineComponent({
       
       setup() {
              const t = useI18n().t;

              const authInfo = reactive({
                     phoneNumber: null,
                     password: null,
              });

              const rules = computed(() => ({
                     phoneNumber: { required, numeric },
                     password: { required },
              }));

              const v$ = useValidate(rules, authInfo);

              return { authInfo, v$, t };
       },
       name: 'LoginForm',
       data() {
              return {
                     loading: false,
                     showPassword: false,
              };
       },
       methods: {
              async auth() {
                     this.v$.$validate();
                     if (!this.v$.$error) {
                            this.loading = true;
                            try {
                                   const res = await Login(this.authInfo);
                                   const cookie = useCookie('UserInfo', {
                                          maxAge: 3600 * 24,
                                          secure: false,
                                          domain: '',
                                          path: '/',
                                          sameSite: 'lax',
                                   }) as any;
                                   cookie.value = res;
                                   navigateTo('/');
                            } catch (error) {
                                   ErrorAlert(error);
                            } finally {
                                   this.loading = false;
                            }
                     }
              },
       },
});
</script>

<style scoped></style>
